import { differenceInMilliseconds } from "date-fns";
export const lastDate = (a, b) => differenceInMilliseconds(a, b);
export const lastPeriod = (a, b) => a.horizontalPosition - b.horizontalPosition;
export const lastSinglePeriod = (a, b) => differenceInMilliseconds(b.endInclusive, a.endInclusive);
//# sourceMappingURL=sort.js.map